import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

export class OpenNewDailyDialogCommand extends AbstractCommand<void> {

    public name: CommandName = CommandName.OPEN_NEW_DAILY_DIALOG;

    public tags = ['ui', 'dialog', 'daily', 'create'];

    constructor() {
        super('daily', 'new', undefined);
    }
}